<template>
  <div class="container">
    <Loading :loading="loading" size="50px" background="rgba(255, 255, 255, 0)" style="height: 100%;width: 100%;">
      <!--  wx agentConfig 注入失败  -->
      <div class="entrance-chat-empty" v-if="hasAgentConfErr">
        <Empty>
          <img src="../../stylesheets/images/aftersales-empty-1.png" alt="" slot="icon"/>
          <div slot="desc">
            <p>获取客户信息异常，请刷新页面</p>
            <x-button type="primary" class="empty-primary-btn" @click="reload">刷新当前页面</x-button>
          </div>
        </Empty>
      </div>
      <!--  从群聊进入应用  -->
      <div class="entrance-chat-empty" v-if="hasEntranceByGroup && !loading">
        <Empty :desc="groupEmptyStr">
          <img src="../../stylesheets/images/aftersales-group-empty.png" alt="" slot="icon"/>
        </Empty>
      </div>
      <!--  未获取到外部联系人ID  -->
      <div class="entrance-chat-empty" v-if="!hasGetExternalUserId && !loading">
        <Empty desc="请检查客户与您的好友关系" title="当前获取客户关系异常">
          <img src="../../stylesheets/images/aftersales-empty.png" alt="" slot="icon"/>
        </Empty>
      </div>
    </Loading>
  </div>
</template>

<script>
import Loading from '@/components/Loading/Index.vue'
import { XButton } from '@lx-frontend/cvux'
import Empty from './components/Empty'
import mixin from './mixins/index.mixin'
import cache, { EXTERNAL_USERID_KEY } from '../../common/cache'

export default {
  name: 'aftersalesIndex',
  components: { XButton, Empty, Loading },
  mixins: [mixin],
  data() {
    return {
      loading: true,
      entranceEnv: '',
      hasAgentConfErr: false, // wx agentConfig 是否注入失败
      hasGetExternalUserId: true, // 获取外部联系人id成功
      hasExternalUserInGroup: false, // 群内是否存在外部联系人
      groupEmptyStr: '暂未发现车主，请邀请车主进群'
    }
  },
  computed: {
    // ...mapState({
    //   userInfo: state => state.aftersales.userInfo,
    //   carList: state => state.aftersales.carList
    // }),
    // 通过群聊进入应用
    hasEntranceByGroup() {
      return this.entranceEnv && this.entranceEnv === 'group_chat_tools'
    }
  },
  methods: {
    reload() {
      this.switchLoading({ status: true, text: '加载中...' })
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
    async getUserInfo(externalUserId) {
      // 未获取到外部联系人id
      if (!externalUserId) {
        this.hasGetExternalUserId = false
        return
      }
      //  根据外部联系人Id获取绑定的客户信息
      await this.GET_USERINFO_BY_EXID(externalUserId)
      // 客户信息不存在, 跳转完善客户信息页
      if (!this.userInfo.id) {
        this.$router.push({ path: '/aftersales/complement' })
        return
      }

      //  客户信息存在， 获取客户名下所有车辆
      await this.GET_USER_CAR_LIST(this.userInfo.id)
      //  客户名下车辆判断， 一辆车跳转详情页，否则跳转列表页
      this.handleToCarPage()
    },
    async checkChat(chatId) {
      // 获取群内外部联系人列表
      const res = await this.$rest.aftersales.getOwnerServiceGroupCustomerList(chatId)()
      if (res.code) {
        if (res.code === 1007) {
          this.groupEmptyStr = '群主互通许可已失效，请联系门店管家激活'
        } else {
          this.showToast(res.message)
        }
        return
      }
      // 判断群是否是服务群
      const { current_customer, optional_customers } = res.data
      this.hasExternalUserInGroup = optional_customers ? !!optional_customers.length : false
      if (current_customer && current_customer.external_userid) {
        // 缓存群对应的外部联系人ID
        cache.setSessionData(EXTERNAL_USERID_KEY, current_customer.external_userid)
        if (current_customer.default_car_id) {
          this.$router.push({ name: 'aftersalesCarInfo', query: { carId: current_customer.default_car_id, mobile: current_customer.mobile_number } })
        } else {
          await this.getUserInfo(current_customer.external_userid)
        }
        // 不是服务群，跳转到完善客户信息页
      } else {
        if (!this.hasExternalUserInGroup) return
        this.$router.push({ path: '/aftersales/complement' })
      }
    }
  },
  created() {
    // 检查wx agentConfig 是否注入失败
    if (cache.getWechatAgentConfErr()) {
      this.hasAgentConfErr = true
      return
    }

    this.$wechat.promise.then(async wx => {
      try {
        this.loading = true
        this.entranceEnv = await wx.getEntranceEnv()
        // 从群聊环境进入应用
        if (this.hasEntranceByGroup) {
          const chatId = await wx.getCurExternalChat()
          await this.checkChat(chatId)
        } else {
          const externalUserId = await wx.getCurExternalUserId()
          await this.getUserInfo(externalUserId)
        }
      } finally {
        setTimeout(() => {
          this.loading = false
        }, 200)
      }
    }, wx => {
      console.log('微信JSSDK校验错误:', wx.res)
    })
  }
}
</script>

<style lang="less" scoped>
@w2: 75rem;
/deep/ .entrance-chat-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .empty-container {
    position: relative;
    top: -100/@w2;
  }

  .empty-primary-btn {
    background: #3a5999;
    color: #fff;
    margin-top: 40/@w2;
    font-size: 28/@w2;
    width: 265/@w2;
    height: 70/@w2;
    line-height: 70/@w2;
  }
}

</style>
